import React, { useState } from 'react';
import PropTypes from 'prop-types';
// Icons
// import BookmarkEmpty from '../../../assets/bookmark.svg';
// import BookmarkFill from '../../../assets/bookmark-filled.svg';
import CommentIcon from '../../../assets/chat.svg';
import UnReadIcon from '../../../assets/unread.svg';
import LoadingGifIcon from '../../../assets/allen-ajax-loader.gif';
// Redux
// import { bookMarkQuestion } from '../../../actions/digitalDoubtActions';
import { Avatar, Dialog } from '@material-ui/core';
//component
import { Skeleton } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';

export default function QuestionCard(props) {
  const [open, setOpen] = React.useState(false);
  const [isImage, setIsImage] = React.useState(true);
  const [urlToExpand, seturlToExpand] = useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <div
        name="test"
        key={props.key}
        className={props.IsSelfModel ? props.IsHide ? `self-question-card ${'hidden'}` : `self-question-card` : props.IsHide ? `question-card ${'hidden'}` : `question-card`}
        onClick={props.isFetching ? null : props.onClick}
      >

        <div className="question-header">
          <div className="flex-row">
            {props.isFetching ? (
              <Skeleton variant="circle" width={50} height={50} />
            ) : (
              <Avatar src={props.PostByPicture} alt="user" />
            )}
            <div className="user-details">
              <div className="name">
                {props.isFetching ? (
                  <Skeleton variant="text" width={50} />
                ) : (
                  props.PostBy || 'Unknown'
                )}
              </div>
              <div className="date">
                {props.isFetching ? (
                  <Skeleton variant="text" width={100} />
                ) : (
                  props.PostTime
                )}
              </div>
            </div>
          </div>
          <div className="right-panel">
            {/* Screening/Hidden/Rejected prompt */}
            <>
              {(props.IsHide) &&
              props.IsSelfPost &&
              props.userType === 'student' ? (
                props.IsHide ? (
                  props.IsHide ? (
                    <div className="status-label">Hidden</div>
                  ) : (
                    <div className="status-label rejected">Rejected</div>
                  )
                ) : (
                  <div className="status-label">
                    <img src={LoadingGifIcon} />
                    Screening
                  </div>
                )
              ) : null}
            </>
            {/* <React.Fragment>
              {props.isFetching ? null : (
                <div
                  className="bookmark"
                  name="bookmark"
                  onClick={() =>
                    props.IsBookMarked
                      ? bookMarkQuestion(
                          props.QuestionID,
                          5,
                          props.jwtToken,
                          props.dispatch,
                          props.forumCode
                        )
                      : bookMarkQuestion(
                          props.QuestionID,
                          4,
                          props.jwtToken,
                          props.dispatch,
                          props.forumCode
                        )
                  }
                >
                  {props.IsBookMarked ? (
                    <img src={BookmarkFill} name="bookmark" />
                  ) : (
                    <img src={BookmarkEmpty} name="bookmark" />
                  )}
                </div>
              )}
            </React.Fragment> */}
          </div>
        </div>
        <div className="question-body">
          <div className="title">
            {props.isFetching ? (
              <Skeleton variant="text" width={'50%'} />
            ) : (
              props.QuestionTitle
            )}
          </div>
          <div className="desc">
            {props.isFetching ? (
              <>
                <Skeleton variant="text" />
                <Skeleton variant="text" />
              </>
            ) : (
              props.QuestionDetail
            )}
          </div>
        </div>
        <div className="upload-body">
          {props.isFetching ? (
            <Skeleton className="img-container" variant="rect" />
          ) : props.QuestionImage ? (
            <div
              name="image"
              className="img-container"
              style={{ backgroundImage: `url(${props.QuestionImage})` }}
              onClick={() => {
                seturlToExpand(props.QuestionImage);
                setIsImage(true);
                handleClickOpen();
              }}
            />
          ) : null}
          {props.VideoURL ? (
            <div className="vid-container">
              <video
                name="video"
                id="video1"
                width="100%"
                onClick={() => {
                  seturlToExpand(props.VideoURL);
                  setIsImage(false);
                  handleClickOpen();
                }}
              >
                <source src={props.VideoURL} type="video/mp4" />
              </video>
            </div>
          ) : null}
        </div>
        <div className="comments">
          <div className="item">
            {props.isFetching ? (
              <Skeleton variant="text" width={100} />
            ) : (
              <>
                <img src={CommentIcon} />
                {props.TotalComment} Comments
              </>
            )}
          </div>
          {(props.UnreadComment || props.TotalCommentUnread) > 0 && (
            <div className="item">
              <img src={UnReadIcon} />
              {props.UserType === 1
                ? props.TotalCommentUnread || props.UnreadComment
                : props.UnreadComment || props.TotalCommentUnread}{' '}
              Unread
            </div>
          )}
        </div>
      
      
      </div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={'sm'}
        className="simple-dialog"
      >
        <span className="popup-close" onClick={handleClose}>
          <CloseIcon />
        </span>
        <div className="embed-responsive embed-responsive-16by9">
          {isImage ? (
            <img src={urlToExpand} />
          ) : (
            <video
              className="embed-responsive-item"
              height="310"
              width="100%"
              allowFullScreen
              controls
              controlsList="nodownload"
              disablePictureInPicture
            >
              <source src={urlToExpand} type="video/mp4" />
            </video>
          )}
        </div>
      </Dialog>
    </React.Fragment>
  );
}

QuestionCard.propTypes = {
  QuestionTitle: PropTypes.string,
  QuestionDetail: PropTypes.string,
  QuestionImage: PropTypes.string,
  QuestionCode: PropTypes.string,
  PostBy: PropTypes.string,
  PostByPicture: PropTypes.string,
  PostTime: PropTypes.string,
  TotalComment: PropTypes.number,
  DiscussionDetail: PropTypes.string,
  UnreadComment: PropTypes.number,
  TotalCommentUnread: PropTypes.number,
  UserType: PropTypes.number,
  IsSelfPost: PropTypes.bool,
  IsApproved: PropTypes.bool,
  IsReject: PropTypes.bool,
  IsClose: PropTypes.bool,
  IsHide: PropTypes.bool,
  QuestionID: PropTypes.number,
  IsBookMarked: PropTypes.bool,
  MobileContact: PropTypes.string,
  VideoURL: PropTypes.string,
  jwtToken: PropTypes.string,
  forumCode: PropTypes.string,
  dispatch: PropTypes.func,
  userType: PropTypes.string,
  reloadPage: PropTypes.func,
  onClick: PropTypes.func,
  questionCode: PropTypes.string,
  selectedQuestion: PropTypes.object,
  isFetching: PropTypes.bool,
  BackgroundColor: PropTypes.string,
  key: PropTypes.string,
  IsSelfModel: PropTypes.bool,
};
